export default __webpack_public_path__ + "static/media/DaHillPizza.84e63de6.jpg";